<template>
    <div>
        <v-card class="elevation-12">
            <v-toolbar dark color="secondary">
                <v-toolbar-title>User Two Factor Authentication</v-toolbar-title>
            </v-toolbar>
            <v-card-text py-3>
                <v-alert v-model="showAlert" type="error" icon="error"
                         transition="scale-transition"
                         dismissible>
                    {{alertMessage}}
                </v-alert>
                <v-text-field
                        v-model="OTP"
                        prepend-icon="mdi-user-secret"
                        label="One Time Password"
                        color="secondary"
                        v-on:keypress.enter="submit2FA()"
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-layout row wrap justify-center>
                    <v-btn dusk="user2FALoginButton" color="secondary" @click="submit2FA()">
                        Login
                    </v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
            },
            route: {
                type: String,
                default: '/user/auth/login/2fa',
            },
        },
        data() {
            return {
                OTP: '',
                showAlert: false,
                alertMessage: '',
            };
        },
        methods: {
            submit2FA() {
                let data = this.data;
                data['OTP'] = this.OTP;
                axios.post(this.route, data)
                    .then(response => {
                        localStorage.setItem('showLoadingAnimation', 'yes');
                        window.location = response.data;
                    })
                    .catch(error => {
                        if (error.response.data.errors) this.alertMessage = error.response.data.errors[Object.keys(error.response.data.errors)[0]].toString();
                        else this.alertMessage = error.response.data.message;
                        this.showAlert = true;
                        setTimeout(() => {
                            this.showAlert = false;
                        }, 5000);
                    });
            },
        },
    };
</script>
